import React from 'react'

import StyledSpinningDots from './StyledSpinningDots'

const Loader = () => (
  <StyledSpinningDots>
    <hr />
    <hr />
    <hr />
    <hr />
  </StyledSpinningDots>
)

export default Loader
